import { apiClient } from './apiClient';

/**
 * Begin an OAuth sign-in.
 *
 * Asks the API for the authorize URL rather than navigating straight at it.
 * That round trip is what lets the server see our `X-App-Token` and mint a
 * signed `state` carrying the guest identity, so a guest who signs up with
 * Google keeps their favorites and scores (D31). A plain link couldn't send
 * the header. The same `state` is the flow's CSRF protection.
 *
 * @param {string} provider - OAuth provider
 */
export const initiateOAuthLogin = async (provider) => {
  const { url } = await apiClient.post(`/auth/${provider}/start`, {});
  window.location.href = url;
};

/**
 * Complete OAuth signup with username
 * @param {string} tempToken - Temporary token from OAuth callback
 * @param {string} username - Selected username
 * @returns {Promise<{user: object, token: string}>}
 */
export const completeOAuthSignup = async (tempToken, username) => {
  const response = await apiClient.post('/auth/complete-signup', {
    tempToken,
    username,
  });
  return response;
};

/**
 * Parse OAuth callback parameters from URL
 * @param {string} search - URL search string (e.g., window.location.search)
 * @returns {object} Parsed parameters
 */
export const parseOAuthCallback = (search) => {
  const params = new URLSearchParams(search);
  return {
    token: params.get('token'),
    tempToken: params.get('tempToken'),
    needsUsername: params.get('needsUsername') === 'true',
    suggestedUsername: params.get('suggestedUsername') || '',
    oauth: params.get('oauth'),
    error: params.get('error'),
    message: params.get('message'),
  };
};